module.exports = __webpack_public_path__ + "static/media/daniel.81e60934.jpg";